<template>
<div class="chapter">
<div class="inner_page">
<div class="section level2" id="a-midsummer-nights-dream">
<p style="padding-top: 150px; text-align: center;">A whisper of sunshine spilled across the floor,</p>
<p>The promise of pleasure we’d share forevermore.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?1a349cd4